Ember.Application.initializer
  name: 'inflectorSettings'

  initialize: (container, application) ->
    inflector = Ember.Inflector.inflector
    inflector.irregular('billing_info', 'billing')
    inflector.irregular('order_bonus',  'order_bonuses')
    inflector.irregular('bonus',  'bonuses')
    inflector.irregular('logistics_staff',  'logistics_staff')
